import React, { useEffect } from "react";
import { FormProvider, useForm } from "react-hook-form";
import Input from "../../Common/Input/Input";
import { yupResolver } from "@hookform/resolvers/yup";
import { errorTypes } from "../../../utils/errorTypes";
import {
  changePasswordActionHandler,
  logoutActionHandler,
} from "../../../store/actions/actionHandlers/loginActionHandler";
import { setErrorHandler } from "../../../store/actions/actionHandlers/errorActionHandler";
import { changePasswordSchema } from "../../../utils/preloginAndLoginSchema";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router";
import { useDispatch } from "react-redux";
import classes from "./ChangePasswordModal.module.scss";
import Button from "../../Common/Button/Button";
import { FormattedMessage } from "react-intl";

const ChangePasswordForm = ({
  setChangePasswordModal,
  setChangePasswordCompleteModal,
}) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loginState = useSelector((state) => state.loginReducer);
  const { login, changePasswordLoader } = loginState;
  const { FAIL, SUCCESS } = errorTypes;

  const methods = useForm({
    defaultValues: { Password: "", NewPassword: "", ReEnterNewPassword: "" },
    resolver: yupResolver(changePasswordSchema),
    mode: "onChange",
  });

  const {
    handleSubmit,
    formState: { errors, isValid },
    setFocus,
    reset,
    setValue,
  } = methods;

  useEffect(() => {
    let isResetRequired =
      login?.IsResetRequired || localStorage.getItem("isResetRequired");
    if (isResetRequired === "true" || isResetRequired === true) {
      setFocus("NewPassword");
      setChangePasswordModal(() => true);
    }
  }, [setFocus, login, setChangePasswordModal]);

  const handleModals = () => {
    setChangePasswordModal(() => false);
    setChangePasswordCompleteModal(() => true);
  };

  const onSubmit = (data) => {
    const currentPassword = localStorage.getItem("userPassword");
    if (currentPassword) {
      dispatch(
        changePasswordActionHandler(currentPassword, data.NewPassword)
      ).then((data) => {
        if (data !== null) {
          switch (data.Code) {
            case 1001:
              dispatch(setErrorHandler(FAIL, data.Description));
              setFocus("NewPassword");
              reset();
              break;
            case 1002:
              dispatch(
                setErrorHandler(
                  FAIL,
                  "Old Password and New Password should not be same"
                )
              );
              setFocus("NewPassword");
              reset();
              break;
            case 1006:
              dispatch(
                setErrorHandler(
                  SUCCESS,
                  "User Password is updated successfully"
                )
              );
              handleModals();
              break;
            case 1010:
              dispatch(
                setErrorHandler(
                  FAIL,
                  "Choose a password that is different from your last 5 passwords"
                )
              );
              setFocus("NewPassword");
              reset();
              break;
            default:
              break;
          }
        }
      });
    } else {
      dispatch(logoutActionHandler(navigate));
    }
  };

  return (
    <FormProvider {...methods}>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={classes.changePassword__form}
      >
        <Input
          name={"Password"}
          type={"password"}
          hidden={true}
          height="0"
          gap="0"
        />

        <Input
          label={"New password"}
          name={"NewPassword"}
          type={"password"}
          placeholder={""}
          height="5"
          width="30"
          direction="row"
          error={errors?.["NewPassword"]?.message}
          errorPosition="absolute"
          required
          gap="10"
          onChange={(e) => setValue("Password", e.target.value)}
        />
        <Input
          label={"Re-enter new password"}
          name={"ReEnterNewPassword"}
          type={"password"}
          placeholder={""}
          height="5"
          width="30"
          direction="row"
          error={errors?.["ReEnterNewPassword"]?.message}
          errorPosition="absolute"
          required
          gap="4.1"
        />
        <div className={classes.changePassword__form__footer}>
          <div className={classes.changePassword__form__footer__warning}>
            * Mandatory Fields
          </div>
          <Button
            label={<FormattedMessage id="P_SAVE_TXT" />}
            disabled={!isValid}
            type="submit"
            small
            dark
            loading={changePasswordLoader}
          />
        </div>
      </form>
    </FormProvider>
  );
};

export default ChangePasswordForm;
